/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'download-arrow': {
    width: 16,
    height: 16,
    viewBox: '0 0 41.712 41.712',
    data: '<path pid="0" d="M31.586 21.8a1.112 1.112 0 0 0 0-1.587 1.093 1.093 0 0 0-1.571 0l-8.047 8.032V1.706c0-.619-.492-1.127-1.111-1.127s-1.127.508-1.127 1.127v26.539l-8.031-8.032a1.112 1.112 0 0 0-1.587 0 1.112 1.112 0 0 0 0 1.587l9.952 9.952a1.14 1.14 0 0 0 1.587 0l9.935-9.952zm7.888 7.286c0-.619.492-1.111 1.111-1.111s1.127.492 1.127 1.111v10.92c0 .619-.508 1.127-1.127 1.127H1.111A1.118 1.118 0 0 1 0 40.006v-10.92c0-.619.492-1.111 1.111-1.111s1.127.492 1.127 1.111v9.809h37.236v-9.809z" _fill="#1e201d"/>'
  }
})
